module.exports = __webpack_public_path__ + "img/DE00942.a1186c0c.png";